import React from 'react'

import {
    Tabs,
    Tab,
    makeStyles,
} from '@material-ui/core'

import {
    COLOR
} from '../../business-const/Color/Color'

import { 
    IsXsDownScreen
} from '../../business-components/Service/GlobalService'

const useStyles = makeStyles(theme => ({
    indicator: ({ level }) => ({
        backgroundColor: COLOR().bgTabsPadraoIndicator,
        height: (level === 3 ? "7px" : level === 2 ? "9px" : "11px"),
        top: "45px",
        borderRadius: "5px",
    }),
    tabsWrapper: {
        marginTop: "10px",
        marginBottom: "10px",
        height: "60px",
        color: COLOR().tabsPadraoColor,
    }
}))

export const TabsPadrao = props => {

    const { level, ...rest } = props

    const classes = useStyles({level})

    const isXsDownScreen = IsXsDownScreen()

    return (
        <Tabs
            className={classes.tabsWrapper}
            TabIndicatorProps={{ className: classes.indicator }}
            variant="scrollable"
            scrollButtons={isXsDownScreen ? "on" : "auto"}
            {...rest}
        />
    )
}

export const TabPadrao = props => {

    const { level, ...rest } = props

    return (
        <Tab
            className={"none font-medium " + (level === 3 ? "text-14" : level === 2 ? "text-16" : "text-20")}
            {...rest}
        />
    ) 
}
